import { Component, OnDestroy } from '@angular/core';
import { PrivacyPolicyService } from './privacy-policy.service';
import { Router } from "@angular/router";

@Component({
  moduleId: module.id,
  selector: 'bft-privacy-policy',
  styleUrls: ['privacy-policy.component.css'],
  templateUrl: 'privacy-policy.component.html',
  providers: [PrivacyPolicyService],
})
export class PrivacyPolicyComponent implements OnDestroy {

  model;
  statusAgree = false;

  displayDialog: boolean = false;

  loading: boolean = false;
  errorMessage: string;
  serverValidationErrorMessage: any;

  constructor(private privacyPolicyService: PrivacyPolicyService, private router: Router,) {
  }

  ngOnInit() {
    this.displayDialog = !this.getPrivacyPolicyStatus();
  }

  handleDialogHide($event) {
    this.model = '';
    this.serverValidationErrorMessage = '';
    this.errorMessage = '';
  }

  hide($event) {
    $event.preventDefault();
    this.displayDialog = false;
    this.router.navigate(['/']);
  }

  apply($event) {
    $event.preventDefault();
    if(!this.statusAgree) {
      return;
    }

    this.privacyPolicyService.save('true');
    this.displayDialog = false;
  }

  getPrivacyPolicyStatus() {
    return this.privacyPolicyService.getStatus();
  }

  ngOnDestroy() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/main/privacy-policy/privacy-policy.component.ts